import {
  DOWNLOAD_ACTIVITY_FILE_FAILURE,
  DOWNLOAD_ACTIVITY_FILE_REQUEST,
  DOWNLOAD_ACTIVITY_FILE_SUCCESS,
  FETCH_ACTIVITY_LIST_FAILURE,
  FETCH_ACTIVITY_LIST_REQUEST,
  FETCH_ACTIVITY_LIST_SUCCESS,
} from "./actionTypes";
import { ActivityLogState } from "./types";

const initialState: ActivityLogState = {
  activityList: [],
  loading: false,
  error: null,
  downloadLoading: false,
  downloadError: null,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LIST_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
        activityList: []
      };
    case FETCH_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        activityList: action.payload,
        error: null,
      };
    case FETCH_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    case DOWNLOAD_ACTIVITY_FILE_REQUEST:
      return {
        ...state,
        downloadLoading: true,
        downloadError: null,
      };
    case DOWNLOAD_ACTIVITY_FILE_SUCCESS:
      return {
        ...state,
        downloadLoading: false,
        downloadError: null,
      };
    case DOWNLOAD_ACTIVITY_FILE_FAILURE:
      return {
        ...state,
        downloadLoading: false,
        downloadError: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
